<template>
  <simple-dialog
      v-model="visible"
      title-text="サイト切替"
      apply-text="切替"
      :valid="selectedTerminalId !== currentTerminalId"
      @close="onClose"
      @apply="onApply">
    <el-table
        :data="availableTerminals"
        row-key="id"
        :row-class-name="rowClassName"
        @row-click="handleSelectionChange">
      <el-table-column
          prop="id"
          label="サイトID"
          width="120">
      </el-table-column>
      <el-table-column
          label="サイト名"
          prop="name"
          width="200">
        <template #default="{row}">
          {{ row.name }}
          <template v-if="row.belongs">
            <el-tooltip content="現在表示しているサイトです" placement="right" :open-delay="500">
              <v-icon small>mdi-account-box</v-icon>
            </el-tooltip>
          </template>
        </template>
      </el-table-column>
      <el-table-column
          prop="description"
          label="説明">
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.description"
                placeholder="未設定"
                multi-line>
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>
    </el-table>
  </simple-dialog>
</template>

<script>
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import {mapGetters, mapMutations} from "vuex";
import TableInline from "@/components/atoms/TableInline.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";

export default {
  name: "TerminalSwitchDialog",
  components: {TextFieldLike, TableInline, SimpleDialog},
  props: {
    value: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      visible: false,
      selectedTerminalId: null,
    }
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      hcsClient: 'hcs/client',
    }),
    availableTerminals() {
      return this.account.user?.availableTerminals?.map(t => ({
        ...t,
        belongs: t.id === this.currentTerminalId
      })) ?? [];
    },
    currentTerminalId() {
      return this.account.user?.terminalId ?? '';
    }
  },
  methods: {
    rowClassName({row}) {
      return row.id === this.selectedTerminalId ? 'current-row' : '';
    },
    handleSelectionChange(row) {
      this.selectedTerminalId = row.id;
    },
    onApply() {
      this.onClose();
      this.$emit("apply", this.selectedTerminalId);
    },
    onClose() {
      this.visible = false;
      this.$emit('input', false);
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        if(newValue !== oldValue) {
          this.visible = newValue;
          if(newValue) {
            this.selectedTerminalId = this.currentTerminalId;
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.el-table ::v-deep .el-table__body-wrapper tr {
  cursor: pointer;
}
</style>
